<template>
  <div class="flex items-center">
    <el-select v-model="filter.type" placeholder="Select">
      <el-option
        v-for="(option, index) in options"
        :key="index"
        :label="option"
        :value="option"
      >
      </el-option>
    </el-select>
    <el-date-picker
      v-model="filter.startDate"
      type="date"
      placeholder="Pick start date"
      class="mx-1"
      value-format="yyyy-MM-dd"
    >
    </el-date-picker>
    <el-date-picker
      v-model="filter.endDate"
      type="date"
      placeholder="Pick end date"
      class="mx-1"
      value-format="yyyy-MM-dd"
    >
    </el-date-picker>
    <base-button text="Search" :loading="loading"  @click="getBookingsByDate"/>
  </div>
</template>-

<script>
export default {
  props: {
    filterFunction: { type: Function },
  },
  data() {
    return {
      options: ["All Shipments"],
      filter: {
        type: "",
        startDate: "",
        endDate: "",
      },
      startTime: "",
      endTime: "",
      loading: false,
      filteredData: []
    };
  },
  watch: {
    "filter.startDate"(val){
        // alert(val);
        this.startTime = new Date(val +"T00:00:00.000").getTime();
    },
    "filter.endDate"(val){
        // alert(val);
        this.endTime = new Date(val +"T23:59:59.000").getTime();
    }
  },
  methods: {
    async getBookingsByDate(){
      this.loading = true;
      this.$emit("filtering", this.loading)
      try {
        const response = await this.$_getUserBookingByDate(this.startTime, this.endTime);
        this.log(response);
        this.filteredData = response.data.data.shippings;
        this.$emit("filtered", this.filteredData)
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
      this.$emit("filtering", this.loading)
    },
    async filter_callback(){
      
      this.$emit("filtering", true)
      this.$emit("need-function", {startTime:this.startTime, endTime: this.endTime})
      try{
        this.filteredData = await this.$on('need-function-ex',);
        this.$emit("filtering", false)
        this.$emit("filtered", this.filteredData)
      } catch(e){
        this.$emit("filtering", false)
        this.handleError(e);
      }
    }
  }
};
</script>

<style scoped>
.el-select,
.el-date-editor.el-input {
  width: 12rem;
  margin-bottom: 0;
}
</style>
